import React from 'react'
import { cx } from '@/lib/utils'
import styles from './CardShell.module.scss'

type Variant = 'surface' | 'interactive' | 'featured'

interface CardShellProps {
  children: React.ReactNode
  variant?: Variant
}

const variantMap: Record<Variant, string> = {
  surface: styles.surface,
  interactive: styles.interactive,
  featured: styles.featured,
}

export const CardShell: React.FC<CardShellProps> = ({ children, variant = 'surface' }) => (
  <div className={cx(styles.card, variantMap[variant])}>
    {children}
  </div>
)
